/**
 * Reglas de diligenciamiento de los metadatos de Genio tipo TEXTO y NUMERO,
 * las mismas que aplica gestorapi (GEST0004::cleanTrailingSpecialChars): los
 * caracteres especiales (lo que no es letra, numero ni espacio) con los que
 * termina el valor se quitan ("PRUEBA." -> "PRUEBA", "12365," -> "12365") y
 * los que van en medio se conservan ("4500866960/ 4500877144", "FE-1234").
 * Solo aplican a los cargues de la empresa EMPRESA_LIMPIA_METADATOS.
 */

export const EMPRESA_LIMPIA_METADATOS = "800251957";

const RE_ESPECIAL_AL_FINAL = /[^\p{L}\p{N}]*[^\p{L}\p{N}\s][^\p{L}\p{N}]*$/u;
const RE_NO_NUMERICO = /[^\d.,]/g;

/**
 * Limpia el valor mientras se digita. En NUMERO solo deja digitos y
 * separadores, como hacia el input numerico. El especial del final no se
 * quita aqui porque cortaria "FE-" antes de que se digite el resto.
 * @param {*} mValor Valor digitado
 * @param {string} cTipo METTIPXX del metadato
 * @returns {string}
 */
export const limpiarMetadatoAlEscribir = (mValor, cTipo) => {
  const cValor = String(mValor ?? "");
  return cTipo === "NUMERO" ? cValor.replace(RE_NO_NUMERICO, "") : cValor;
};

/**
 * Limpia el valor al salir del campo: quita los caracteres especiales con
 * los que termina.
 * @param {*} mValor Valor digitado
 * @param {string} cTipo METTIPXX del metadato
 * @returns {string}
 */
export const limpiarMetadatoAlSalir = (mValor, cTipo) =>
  limpiarMetadatoAlEscribir(mValor, cTipo).replace(RE_ESPECIAL_AL_FINAL, "");

/**
 * Indica si los metadatos del cargue se limpian: solo los de EMPRESA_LIMPIA_METADATOS.
 * @param {string|number} EMPNITXX Empresa del cargue
 * @returns {boolean}
 */
export const aplicaLimpiezaMetadatos = (EMPNITXX) => String(EMPNITXX ?? "") === EMPRESA_LIMPIA_METADATOS;
